<template>
  <div
    _comment="tab list"
    class="lego-dropdown__items"
    v-show="isItemShowing"
    :class="itemsClass"
    style="overflow: visible"
  >
    <lego-tab-box :default-idx="tabIdx" @tab-change="_tabChange">
      <lego-tab-label :idx="1">{{ $t('label.searchPeriod') }}</lego-tab-label>
      <lego-tab-label :idx="2">{{ $t('label.directInput') }}</lego-tab-label>
    </lego-tab-box>
    <!-- <div style="display: inline-block;">isPerformance: {{isPerformance}}</div>
    <div style="display: inline-block; padding-left: 20px">isMonitoringPerformance: {{isMonitoringPerformance}}</div> -->
    <div class="datepicker-tab-container">
      <!-- <scpm-sub-title class="ui-stitle">조회 기간</scpm-sub-title> -->
      <div v-show="tabIdx == 1" _comment="tab1 조회기간" class="period-type-wrap tab-type">
        <lego-segment-wrapper v-model="tab1value" :isDatePicker="true">
          <template v-for="(item, idx) in dateItem" :key="idx">
            <lego-segment-button
              :value="item.value"
              @click.stop="_doAction({ idx, ...item })"
              :class="tab1selectIndex <= idx ? 'selected' : ''"
              :disabled="idx == 9"
            >
              <em>{{ item.text }}</em>
            </lego-segment-button>
          </template>
        </lego-segment-wrapper>
      </div>
      <div v-show="tabIdx == 2" _comment="tab2 직접입력" class="datatime-type-wrap">
        <div class="date-time">
          <scpm-date-time-picker
            v-model="dateValue"
            range
            @update:modelValue="updateValue"
            :maxDate="getMaxDate"
            :up="datePickerPositionUp"
            :isError="dateValidate.isError"
            @changeInputDate="changeInputDate"
          />
          <div v-if="dateValidate.isError" class="message">{{ dateValidate.errorMsg }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import i18nMixin from '@/mixins/i18n.mixin.js';
import legoValidatorMixin from '@/lego-component/mixins/legoValidator/legoValidatorMixin.vue';
import { mapState } from 'vuex';

const UNSELECT_DROPDOWN_TITLE = 'Select';
const DEFAULT_ITEM_TEXT = 'text';
const DEFAULT_ITEM_VALUE = 'value';

export default {
  name: 'multi-date-picker-extend-tab',
  emits: ['onToggle', 'tabChange', 'input', 'confirm', 'dataChange', 'updateDateValueOld'],
  mixins: [legoValidatorMixin, i18nMixin],
  inject: {
    legoInput: { from: 'legoInput', default: () => undefined },
    strDate: { from: 'startDate', default: () => undefined },
    updateInquiry: {
      from: 'updateInquiry'
    }
  },
  props: {
    index1Value: { type: String, default: '30m' },
    items: { type: Array, default: () => [] },
    value: { type: [String] },
    tabType: { type: Number, default: 1 },
    placeholder: { type: String },
    width: { type: [Number, String] /*px*/ },
    height: { type: [Number, String] /*px*/ },
    itemText: { type: [String, Function], default: DEFAULT_ITEM_TEXT },
    itemValue: { type: String, default: DEFAULT_ITEM_VALUE },
    inputValue: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    successMessage: { type: String, default: undefined },
    messageStyle: {
      type: String,
      validator: function (value) {
        return ['heavy', 'light'].indexOf(value) !== -1;
      },
      default: 'heavy'
    },
    medium: { type: Boolean, default: false },
    md: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    sm: { type: Boolean, default: false },
    up: { type: Boolean, default: false },
    rowId: { type: [Number, String] },
    autoOpen: { type: Boolean, default: true },
    isPerformance: { type: Boolean, default: false },
    isMonitoringPerformance: { type: Boolean, default: false },
    dateValueOld: { type: Array, default: () => [] },
    datePickerPositionUp: { type: Boolean, default: false },
    isDashboard: { type: Boolean, default: false },
    isLogDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateItem: [
        { value: '14d', text: '14 ' + this.$t('label.day') },
        { value: '7d', text: '7 ' + this.$t('label.day') },
        { value: '3d', text: '3 ' + this.$t('label.day') },
        { value: '24h', text: '24 ' + this.$t('label.hour') },
        { value: '12h', text: '12 ' + this.$t('label.hour') },
        { value: '6h', text: '6 ' + this.$t('label.hour') },
        { value: '3h', text: '3 ' + this.$t('label.hour') },
        { value: '60m', text: '60 ' + this.$t('label.minute') },
        { value: '30m', text: '30 ' + this.$t('label.minute') },
        { value: '0', text: 'Now' }
      ], // 조회기간 버튼배열

      default: {
        size: 'medium',
        placeholder: UNSELECT_DROPDOWN_TITLE
      },

      isItemShowing: false,
      tabIdx: 1, // {1:조회기간, 2:직접입력}
      tab1value: '', // 조회기간 - 값
      tab1Text: '', // 조회기간 - 라벨
      tab1selectIndex: 99, // 조회기간 - 라벨
      resultValue: '', // v-model
      dateValidate: {
        isError: false,
        errorMsg: ''
      },
      lastSelected: {},
      fromMaxDate: '',
      toMaxDate: '',
      selected: 'Current Time',
      startDate: '',
      endDate: '',
      dateValue: [],
      defaultDate: []
    };
  },
  computed: {
    ...mapState({
      searchDateDashboard: (state) => state.dashboardState.searchDateDashboard
    }),
    getMaxDate() {
      return moment().format('YYYY-MM-DD HH:mm');
    },
    validateTarget() {
      return this.value;
    },
    hasChildItems() {
      let flag = false;
      this.items.forEach((item) => {
        flag = flag || !!item.childItems;
      });
      return flag;
    },
    itemsClass() {
      let clazz = [];
      if (this.hasChildItems) clazz.push('lego-dropdown__items--has-child-items');
      return clazz;
    },
    getTab1Value() {
      return this.tab1value;
    },
    timePeriod() {
      return this.lastSelected.tab1value.replace(/[^0-9]/g, '');
    },
    unitPeriod() {
      return this.lastSelected.tab1value.replace(/[0-9]/g, '');
    }
  },
  watch: {
    value() {},
    items() {},
    tab1value() {
      this.isChangedData();
    },
    validateTarget() {
      this.validateOnEvent(); // whenever checked value changes, execute validate() if lazy is false
    },
    successMessage: {
      immediate: true,
      handler(val) {
        this.showValid = !!val;
      }
    },
    strDate: {
      immediate: true,
      handler(val) {
        if (!val) {
          if (this.lastSelected.tabIdx === 1) {
            this.tabIdx = 1;
          }
          this.setDefalut();
        }
      }
    }
  },
  created() {
    this.tab1value = this.index1Value;
    if (this.isDashboard && this.searchDateDashboard) {
      this.tab1value = this.searchDateDashboard.tab1value;
    }

    const indexTabActive = this.dateItem.findIndex((item) => item.value == this.index1Value);
    if (indexTabActive > -1) {
      this.tab1selectIndex = indexTabActive;
      this.tab1Text = this.dateItem[indexTabActive].text;
    }

    // for (let i = 0; i < this.dateItem.length; i++) {
    //   if (this.dateItem[i].value == this.tab1value) {
    //     this.tab1selectIndex = i;
    //     this.tab1Text = this.dateItem[i].text;
    //     break;
    //   }
    // }

    this.resultValue = this.tab1value;
    this.setDefalut();
  },
  mounted() {
    const unit = this.$util.getPeriodUnit(this.unitPeriod);
    this.tabIdx = this.tabType;
    this.fromMaxDate = moment().subtract(this.timePeriod, unit).format('YYYY-MM-DD HH:mm');
    this.toMaxDate = moment().format('YYYY-MM-DD HH:mm');

    if (this.strDate) {
      this.tabIdx = 2;
      this.toMaxDate = moment(this.strDate).format('YYYY-MM-DD HH:mm');
      this.fromMaxDate = moment(this.strDate)
        .subtract(this.timePeriod, unit)
        .format('YYYY-MM-DD HH:mm');
      this.defaultDate = [this.fromMaxDate, this.toMaxDate];
    }
    if (this.searchDateDashboard && this.isDashboard) {
      this.tabIdx = this.searchDateDashboard.dateType;
      this.fromMaxDate = moment(this.searchDateDashboard.queryStartDt).format('YYYY-MM-DD HH:mm');
      this.toMaxDate = moment(this.searchDateDashboard.queryEndDt).format('YYYY-MM-DD HH:mm');
    }

    this.dateValue = [this.fromMaxDate, this.toMaxDate];

    if (this.tabIdx === 1) {
      const indexTabActive = this.dateItem.findIndex((item) => item.value == this.index1Value);
      if (indexTabActive > -1) {
        this._doAction({ idx: indexTabActive, ...this.dateItem[indexTabActive] });
      }
      // this.dateItem.forEach((t, idx) => {
      //   if (t.value === this.tab1value) {
      //     this._doAction({ idx, ...t });
      //   }
      // });

      if (!this.autoOpen) this.toggleItemOuter();
    }
  },
  methods: {
    toggleItem() {
      this.isItemShowing = !this.isItemShowing;
      this.$emit('onToggle', 'toggle');
    },
    toggleItemOuter() {
      this.isItemShowing = false;
    },

    _tabChange(idx) {
      this.isTab1ItemClick = false;
      this.tabIdx = idx;
      this.dateValidate = {
        isError: false,
        errorMsg: ''
      };
      this.$emit('tabChange', idx);
      this.isChangedData();
    },
    getCurrentDate() {
      if (this.lastSelected.tabIdx === 1) {
        let time = this.timePeriod;
        const unit = this.unitPeriod;

        if (this.isLogDate && unit == 'd') time = time - 1;

        const timeOfTab = { '3d': '10m', '7d': '30m', '14d': '1h' };
        const _chartTimeUnit = timeOfTab[this.lastSelected.tab1value] || '5m';

        const endDate = moment();
        const startDate = moment(endDate).subtract(time, this.$util.getPeriodUnit(unit));
        return {
          queryStartDt: startDate.toISOString(),
          queryEndDt: endDate.toISOString(),
          chartTimeUnit: _chartTimeUnit,
          tab1value: this.getTab1Value,
          dateType: this.tabIdx,
          tab1Text: this.tab1Text,
          isNow: true
        };
      } else {
        const start = moment(this.dateValue[0]);
        const end = moment(this.dateValue[1]);
        const diffMin = moment.duration(end.diff(start)).asMinutes();

        let _chartTimeUnit = '';
        if (diffMin <= 20160) _chartTimeUnit = '1h'; // 14d
        if (diffMin <= 10080) _chartTimeUnit = '30m'; // 7d
        if (diffMin <= 4320) _chartTimeUnit = '10m'; // 3d
        // if(diffMin > 1440) _chartTimeUnit = '1h'  // 3d
        if (diffMin <= 1440) _chartTimeUnit = '5m'; // 1d 미만

        return {
          queryStartDt: start.toISOString(),
          queryEndDt: end.toISOString(),
          //chartTimeUnit: diffMin <= 360 ? '1m' : diffMin <= 4320 ? '1h' :'1d'
          chartTimeUnit: _chartTimeUnit,
          dateType: this.lastSelected.tabIdx,
          tab1value: this.getTab1Value
        };
      }
    },

    //If cdn, when select direct input, switch tab search period, user select less than 24 hours,
    // rollback previous selected date
    handleCdnDateSelection(date) {
      this._tabChange(2);
      const { queryEndDt = '', queryStartDt = '' } = date;
      const dateStart = moment(queryStartDt).format('YYYY-MM-DD HH:mm');
      const dateEnd = moment(queryEndDt).format('YYYY-MM-DD HH:mm');
      this.dateValue = [dateStart, dateEnd];
      const idx = this.dateItem.findIndex(t => t.value === date.tab1value);
      if(idx >= 0){
        this.tab1selectIndex = idx;
        this.tab1value = date.tab1value;
        this.tab1Text = this.dateItem[idx].text;
      }
      this.$emit('updateDateValueOld', [queryStartDt, queryEndDt]);
    },

    setDate(date, callback, cdn = false) {
      this.$nextTick(() => {
        if ((typeof date === 'string' || date.dateType == 1) && !this.strDate) {
          this._tabChange(1);
        } else if (this.strDate) {
          this._tabChange(2);
        }

        if (typeof date === 'string') {
          this.dateItem.forEach((t, idx) => {
            if (t.value === date) {
              //console.log(t);
              this._doAction({ idx, ...t });
              this.setDefalut();
              if (callback && typeof callback === 'function') callback();
            }
          });
        } else {
          if (date.dateType == 1) {
            this.dateItem.forEach((t, idx) => {
              if (t.value === date.tab1value) {
                this._doAction({ idx, ...t });
                this.setDefalut();
                if (callback && typeof callback === 'function') callback();
              }
            });
          } else {
            if (cdn) this.handleCdnDateSelection(date);
            this.setDefalut();
          }
        }
        this.updateInquiry();
      });
    },
    // 액션 모음
    _doAction(parms) {
      // 탭1 버튼 클릭
      this.isTab1ItemClick = true;
      this.tab1selectIndex = parms.idx;
      this.tab1value = parms.value;
      this.tab1Text = parms.text;
      this.resultValue = parms.value;

      this.toggleItem();
      this.$emit('input', this.resultValue);
      const startDate = this.dateValue[0];
      const endDate = this.dateValue[1];

      let result = {
        rowId: this.rowId || '',
        tabIdx: this.tabIdx,
        tab1value: this.tab1value,
        tab1Text: this.tab1Text,
        startDate,
        endDate
      };
      this.$emit('confirm', result);
    },
    setDefalut(isCheck = false, isReset = false) {
      if (this.searchDateDashboard && this.isDashboard && !isCheck) {
        this.tabIdx = this.searchDateDashboard.dateType;
      }
      if (isReset) {
        this.tabIdx = 1;
      }
      this.lastSelected = {
        tabIdx: this.tabIdx,
        tab1value: this.tab1value, // 조회기간 - 값
        tab1Text: this.tab1Text, // 조회기간 - 라벨
        tab1selectIndex: this.tab1selectIndex // 조회기간 - 라벨
      };
      this.dateValidate = {
        isError: false,
        errorMsg: ''
      };
    },
    isChangedData() {
      let isChange = false;
      if (this.lastSelected.tabIdx !== this.tabIdx) {
        isChange = true;
        this.$emit('dataChange', true);
      } else if (this.tabIdx === 1) {
        isChange = this.tab1value !== this.lastSelected.tab1value;
      }
      this.$emit('dataChange', isChange);
    },
    loadDefault() {
      this.$nextTick(() => {
        Object.keys(this.lastSelected).forEach((k) => {
          this[k] = this.lastSelected[k];
          let dataTimeOld = [];
          if (this.dateValueOld.length) {
            dataTimeOld = this.dateValueOld;
          }
          if (
            this.searchDateDashboard &&
            this.isDashboard &&
            this.searchDateDashboard.dateType == 2
          ) {
            dataTimeOld = [
              this.searchDateDashboard.queryStartDt,
              this.searchDateDashboard.queryEndDt
            ];
          }
          if (dataTimeOld.length) {
            const dateStart = moment(dataTimeOld[0]).format('YYYY-MM-DD HH:mm');
            const dateEnd = moment(dataTimeOld[1]).format('YYYY-MM-DD HH:mm');
            this.dateValue = [dateStart, dateEnd];
          }
        });
        this.$emit('tabChange', this.lastSelected.tabIdx);
      });
    },
    updateValue(value) {
      this.dateValidate = {
        isError: false,
        errorMsg: ''
      };
      let dateCompare = [];
      if (this.dateValueOld.length) {
        const dateStart = moment(this.dateValueOld[0]).format('YYYY-MM-DD HH:mm');
        const dateEnd = moment(this.dateValueOld[1]).format('YYYY-MM-DD HH:mm');
        dateCompare.push(dateStart, dateEnd);
        this.compareDateTime(dateCompare, value);
      } else {
        this.compareDateTime(this.defaultDate, value);
      }
    },
    changeInputDate(value) {
      this.updateValue(value);
    },
    compareDateTime(oldValue, newValue) {
      if (this.lastSelected.tabIdx !== this.tabIdx) {
        this.$emit('dataChange', true);
        return;
      }
      if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        this.$emit('dataChange', true);
      } else {
        this.$emit('dataChange', false);
      }
    },
    checkValidDate() {
      if (this.tabIdx === 1) {
        return true;
      }
      let startDate = this.dateValue[0];
      let endDate = this.dateValue[1];
      return this._isValidDate(startDate, endDate);
    },
    _isValidDate(sDate, eDate) {
      this.dateValidate = {
        isError: false,
        errorMsg: ''
      };
      if (
        !moment(sDate, 'YYYY-MM-DD HH:mm', true).isValid() ||
        !moment(eDate, 'YYYY-MM-DD HH:mm', true).isValid()
      ) {
        this.dateValidate = {
          isError: true,
          errorMsg: this.$t('page.eventFilter.periodIsInvalid')
        };
        return false;
      }

      // moment 는 24:00 정상적인 시간으로 봄... 그래서 추가 체크

      if (moment(sDate).format('HH:mm') == '24:00' || moment(eDate).format('HH:mm') == '24:00') {
        this.dateValidate = {
          isError: true,
          errorMsg: this.$t('page.eventFilter.periodIsInvalid')
        };
        return false;
      }

      let period = moment(eDate, 'YYYY-MM-DD HH:mm').diff(
        moment(sDate, 'YYYY-MM-DD HH:mm'),
        'minutes'
      );
      let endPeriod = moment(eDate, 'YYYY-MM-DD HH:mm').diff(
        moment().format('YYYY-MM-DD HH:mm'),
        'minutes'
      );
      let startPeriod = moment(moment(), 'YYYY-MM-DD HH:mm').diff(
        moment(sDate, 'YYYY-MM-DD HH:mm'),
        'minutes'
      );
      if (endPeriod > 0) {
        this.dateValidate = {
          isError: true,
          errorMsg: this.$t('page.eventFilter.periodIsInvalid')
        };
        return false;
      }
      if (period <= 0) {
        this.dateValidate = {
          isError: true,
          errorMsg: this.$t('page.eventFilter.periodIsInvalid')
        };
        return false;
      }

      if (this.isPerformance && startPeriod > 60 * 24 * 14) {
        //console.log("== isPerformance");
        if (!this.isMonitoringPerformance) {
          return true;
        }
        this.dateValidate = {
          isError: true,
          errorMsg: this.$t('message.invalidStartDt')
          // errorMsg: this.$t('page.eventFilter.startDateRangeIsInvalid')
        };
        return false;
      }

      if (period > 60 * 24 * 14) {
        this.dateValidate = {
          isError: true,
          errorMsg: this.$t('page.eventFilter.periodRangeIsInvalid')
        };
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
// uiMultiDatePickerExtend.scss
.message {
  margin-left: 0px;
  color: #fc434e;
  font-size: 12px;
}

.time-picker {
  width: 80px;
  height: 32px;
  color: #1f2533;
  font-size: 14px;
  font-family: $lego__font-family;
  padding: 0 5px 0 6px;
}
</style>
